module.exports = __webpack_public_path__ + "static/media/IMG_1839.98b607ad.JPG";